import * as React from 'react';
import { cn } from './lib/cn';

export type InfoBoxType = 'info' | 'warning' | 'success' | 'danger';

export interface InfoBoxProps {
  type: InfoBoxType;
  icon?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

const TONE: Record<InfoBoxType, string> = {
  info: 'border-info-100 bg-info-50 text-info-700',
  warning: 'border-warning-100 bg-warning-50 text-warning-700',
  success: 'border-success-100 bg-success-50 text-success-700',
  danger: 'border-danger-100 bg-danger-50 text-danger-700',
};

export function InfoBox({ type, icon, children, className }: InfoBoxProps) {
  return (
    <div
      role={type === 'danger' ? 'alert' : 'status'}
      className={cn(
        'rounded-md border px-4 py-3 text-base-sm',
        TONE[type],
        icon !== undefined && 'flex items-start gap-2',
        className,
      )}
    >
      {icon !== undefined && (
        <span className="mt-0.5 h-4 w-4 shrink-0" aria-hidden>
          {icon}
        </span>
      )}
      {icon !== undefined ? <div className="min-w-0">{children}</div> : children}
    </div>
  );
}
